module.exports = __webpack_public_path__ + "img/sp.89d4c9aa.svg";